// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.Table_table-wrapper__Vdok\\+ {
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  font-family: "Sora", sans-serif;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .Table_table-wrapper__Vdok\\+ {
    padding: 24px;
  }
}
@media (max-width: 768px) {
  .Table_table-wrapper__Vdok\\+ {
    padding: 7px;
    background: transparent;
    border: none;
    box-shadow: none;
  }
}

.Table_table-toolbar__jk1g8 {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}
.Table_table-toolbar__info__SIlLB {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  font-weight: 700;
  color: #5F726B;
}
.Table_table-toolbar__select-container__3wc\\+- select {
  background: #F8F6F2;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 12px;
  padding: 6px 12px;
  font-family: inherit;
  font-weight: 700;
  color: #13231D;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.Table_table-toolbar__select-container__3wc\\+- select:focus {
  border-color: #82B194;
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.1);
}

.Table_table-responsive__pswaX {
  width: 100%;
  flex: 1 1;
  overflow-x: hidden;
}

.Table_table-main__NtuYc {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
}
.Table_table-main__body__p\\+Eb- {
  background: #EFF0EC;
  border-radius: 12px;
  padding: 6px 12px;
  font-family: inherit;
  font-weight: 700;
  color: #13231D;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
@media (max-width: 1024px) {
  .Table_table-main__body__p\\+Eb- {
    padding: 0px;
    background: transparent;
  }
}
.Table_table-main__th-content__zVKjd {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  transition: all 0.2s ease;
}
.Table_table-main__header__aKq7c {
  background: #EFF0EC;
  border-radius: 12px;
}
.Table_table-main__empty__pKe5c {
  background: #EFF0EC;
  border-radius: 12px;
  padding: 6px 12px;
  font-family: inherit;
  font-weight: 700;
  color: #13231D;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.Table_table-main__cell-text__EaZ9x {
  color: #13231D;
  font-weight: 700;
  font-size: 14px;
}
@media (max-width: 768px) {
  .Table_table-main__cell-text__EaZ9x {
    font-size: 11px;
  }
}
.Table_table-main__NtuYc > thead {
  background: #EFF0EC;
  border-radius: 12px;
  padding: 6px 12px;
  font-family: inherit;
  font-weight: 700;
  color: #13231D;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.Table_table-main__th__a2kdl {
  padding: 12px 16px;
  text-align: left;
  vertical-align: middle;
}
@media (max-width: 1024px) {
  .Table_table-main__th__a2kdl {
    padding: 12px 10px;
  }
}
.Table_table-main__th--sortable__HlMYk {
  cursor: pointer;
}
.Table_table-main__th--sortable__HlMYk:hover .Table_table-main__sort-icon__wFAhi {
  opacity: 1;
  color: #82B194;
}
.Table_table-main__eyebrow__wMhvu {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5F726B;
}
.Table_table-main__sort-icon__wFAhi {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.35;
  transition: all 0.2s ease;
}
.Table_table-main__sort-icon__wFAhi svg {
  font-size: 16px !important;
}
.Table_table-main__row__Yayus {
  background: #fafafa;
  transition: all 0.2s ease;
}
.Table_table-main__row__Yayus:hover {
  background: #F8F6F2;
  transform: translateY(-1px);
}
.Table_table-main__row--reminded__5yVg7 {
  background: rgba(214, 166, 64, 0.04);
}
.Table_table-main__row--reminded__5yVg7 .Table_table-main__cell__lEwLp {
  border-top: 1px solid rgba(214, 166, 64, 0.1);
  border-bottom: 1px solid rgba(214, 166, 64, 0.1);
}
.Table_table-main__row--reminded__5yVg7:hover {
  background: rgba(214, 166, 64, 0.07);
}
.Table_table-main__cell__lEwLp {
  padding: 24px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid rgba(19, 35, 29, 0.08);
  font-size: 14px;
  color: #13231D;
  font-weight: 500;
}
@media (max-width: 1024px) {
  .Table_table-main__cell__lEwLp {
    padding: 12px 10px;
  }
}
.Table_table-main__cell-wrapper__ZQcjz {
  display: flex;
  align-items: center;
  gap: 12px;
}
.Table_table-main__empty-state__HRGT1 {
  padding: 80px 0;
  text-align: center;
  color: #5F726B;
}
.Table_table-main__empty-state__HRGT1 p {
  font-weight: 600;
  font-size: 15px;
}
@media (max-width: 768px) {
  .Table_table-main__NtuYc {
    display: block;
  }
  .Table_table-main__NtuYc thead {
    display: none;
  }
  .Table_table-main__NtuYc tbody {
    display: block;
  }
  .Table_table-main__row__Yayus {
    display: block;
    background: #fff;
    border: 1px solid rgba(19, 35, 29, 0.08);
    border-radius: 20px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  }
  .Table_table-main__cell__lEwLp {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    padding: 8px 0;
    text-align: right;
  }
  .Table_table-main__cell__lEwLp::before {
    content: attr(data-label);
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #5F726B;
    text-align: left;
  }
  .Table_table-main__empty-row__WU0tI {
    display: block;
    width: 100%;
  }
  .Table_table-main__empty__pKe5c {
    display: block;
    width: 100%;
    padding: 0;
    border: none;
    background: transparent;
  }
  .Table_table-main__empty-state__HRGT1 {
    width: 100%;
    display: block;
    padding: 60px 20px;
  }
}

.Table_table-footer__jW1kK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(19, 35, 29, 0.08);
}
.Table_table-footer__info__ik3Ft {
  font-size: 13px;
  font-weight: 700;
  color: #5F726B;
}
@media (max-width: 768px) {
  .Table_table-footer__jW1kK {
    flex-direction: column;
    gap: 20px;
  }
}

.Table_pagination__GXBhQ {
  display: flex;
  gap: 6px;
}
.Table_pagination__btn__IIcxl {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(130, 177, 148, 0.3);
  background: transparent;
  color: #5F726B;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Table_pagination__btn__IIcxl:hover:not(:disabled) {
  background: rgba(130, 177, 148, 0.1);
  border-color: #82B194;
  color: #13231D;
}
.Table_pagination__btn--active__vTgB8 {
  background: #82B194 !important;
  color: #fff !important;
  border-color: transparent !important;
  box-shadow: 0 4px 12px rgba(130, 177, 148, 0.25);
}
.Table_pagination__btn__IIcxl:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.Table_pagination__btn--arrow__ftMQN {
  background: #82B194;
  color: #fff;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(130, 177, 148, 0.25);
}
.Table_pagination__dots__070qq {
  padding: 0 4px;
  color: #5F726B;
  font-weight: 800;
}

.Table_reminder__ZN3tb {
  position: relative;
}
.Table_reminder__tooltip-text__k88MC {
  color: #13231D;
  font-weight: 700;
  font-size: 14px;
}
.Table_reminder__btn__0HJkL {
  background: rgba(214, 166, 64, 0.1);
  color: #D6A640;
  border: none;
  border-radius: 10px;
  padding: 6px;
  cursor: pointer;
  display: flex;
  animation: Table_softPulse__aL-xm 2s infinite;
}
.Table_reminder__tooltip__mKi-F {
  position: absolute;
  bottom: 130%;
  left: 0;
  width: 260px;
  background: #fff;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}
.Table_reminder__ZN3tb:hover .Table_reminder__tooltip__mKi-F {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.Table_reminder__tooltip-inner__bDPBI {
  display: flex;
  gap: 12px;
  text-align: left;
}
.Table_reminder__tooltip-inner__bDPBI strong {
  display: block;
  font-size: 13px;
  color: #13231D;
  margin-bottom: 4px;
}
.Table_reminder__tooltip-inner__bDPBI p {
  margin: 0;
  font-size: 12px;
  color: #5F726B;
  line-height: 1.5;
}

@keyframes Table_softPulse__aL-xm {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ui/Table/Table.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACE,mBDQqB;ECPrB,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,2CDmDY;EClDZ,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AASF;AAPE;EAXF;IAYI,aAAA;EAUF;AACF;AARE;EAfF;IAgBI,YAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;EAWF;AACF;;AARA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAWF;AATE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDnBmB;AC8BvB;AAPI;EACE,mBD7BiB;EC8BjB,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cD/BiB;ECgCjB,aAAA;EACA,eAAA;EACA,yBAAA;AASN;AAPM;EACE,qBDlDe;ECmDf,8CAAA;AASR;;AAHA;EACE,WAAA;EACA,SAAA;EACA,kBAAA;AAMF;;AAHA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAMF;AAJE;EACE,mBD9DmB;EC+DnB,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cD7DmB;EC8DnB,aAAA;EACA,eAAA;EACA,yBAAA;AAMJ;AAJI;EAXF;IAYM,YAAA;IACA,uBAAA;EAON;AACF;AAJE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;AAMJ;AAHE;EACE,mBDvFmB;ECwFnB,mBAAA;AAKJ;AAFE;EACE,mBD5FmB;EC6FnB,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cD3FmB;EC4FnB,aAAA;EACA,eAAA;EACA,yBAAA;AAIJ;AADE;EACE,cDlGmB;ECmGnB,gBAAA;EACA,eAAA;AAGJ;AADI;EALF;IAMM,eAAA;EAIN;AACF;AADE;EACE,mBDlHmB;ECmHnB,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cDjHmB;ECkHnB,aAAA;EACA,eAAA;EACA,yBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;AAEJ;AAAI;EALF;IAMM,kBAAA;EAGN;AACF;AADI;EACE,eAAA;AAGN;AAFM;EAAiC,UAAA;EAAY,cD/I5B;ACqJvB;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cD1ImB;AC8IvB;AADE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;AAGJ;AADI;EACE,0BAAA;AAGN;AACE;EACE,mBAAA;EACA,yBAAA;AACJ;AACI;EACE,mBDnKiB;ECoKjB,2BAAA;AACN;AAEI;EACE,oCAAA;AAAN;AACM;EAAoB,6CAAA;EAA2C,gDAAA;AAGrE;AAFM;EAAU,oCAAA;AAKhB;AADE;EACE,aAAA;EACA,iCAAA;EACA,+CAAA;EACA,eAAA;EACA,cD/KmB;ECgLnB,gBAAA;AAGJ;AADI;EARF;IASM,kBAAA;EAIN;AACF;AAFI;EAAY,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAOpD;AAJE;EACE,eAAA;EACA,kBAAA;EACA,cD3LmB;ACiMvB;AALI;EAAI,gBAAA;EAAkB,eAAA;AAS1B;AANE;EA9IF;IA+II,cAAA;EASF;EAPE;IAAQ,aAAA;EAUV;EATE;IAAQ,cAAA;EAYV;EAVE;IACE,cAAA;IACA,gBAAA;IACA,wCAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,0CAAA;EAYJ;EATE;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;EAWJ;EATI;IACE,yBAAA;IACA,eAAA;IACA,gBAAA;IACA,yBAAA;IACA,sBAAA;IACA,cD7Ne;IC8Nf,gBAAA;EAWN;EAPE;IACE,cAAA;IACA,WAAA;EASJ;EANE;IACE,cAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,uBAAA;EAQJ;EALE;IACE,WAAA;IACA,cAAA;IACA,kBAAA;EAOJ;AACF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;AAMF;AAJE;EACE,eAAA;EACA,gBAAA;EACA,cDlQmB;ACwQvB;AAHE;EAdF;IAc8B,sBAAA;IAAwB,SAAA;EAQpD;AACF;;AANA;EACE,aAAA;EACA,QAAA;AASF;AAPE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,uBAAA;EACA,cDlRmB;ECmRnB,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AASJ;AAPI;EACE,oCAAA;EACA,qBD3SiB;EC4SjB,cD/RiB;ACwSvB;AANI;EACE,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,gDAAA;AAQN;AALI;EAAa,YAAA;EAAc,mBAAA;AAS/B;AANE;EACE,mBD1TmB;EC2TnB,WAAA;EACA,yBAAA;EACA,gDAAA;AAQJ;AALE;EAAU,cAAA;EAAgB,cDlTL;ECkTuB,gBAAA;AAU9C;;AAPA;EACE,kBAAA;AAUF;AARE;EACE,cD1TmB;EC2TnB,gBAAA;EACA,eAAA;AAUJ;AAPE;EACE,mCAAA;EACA,cD3UmB;EC4UnB,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6CAAA;AASJ;AANE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;AAQJ;AALE;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAOJ;AAJE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAMJ;AAJI;EAAS,cAAA;EAAgB,eAAA;EAAiB,cDtWvB;ECsWwC,kBAAA;AAU/D;AATI;EAAI,SAAA;EAAW,eAAA;EAAiB,cDtWb;ECsW+B,gBAAA;AAetD;;AAXA;EACE;IAAK,mBAAA;EAeL;EAdA;IAAM,sBAAA;EAiBN;EAhBA;IAAO,mBAAA;EAmBP;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-muted;\n$bw-border: $border-soft;\n$bw-surface-soft: $color-surface-soft;\n$bw-surface: $color-surface;\n$bw-gold: $color-gold;\n\n.table-wrapper {\n  background: $color-surface;\n  border: 1px solid $bw-border;\n  border-radius: 24px;\n  padding: 32px;\n  box-shadow: $shadow-card;\n  font-family: \"Sora\", sans-serif;\n  min-height: 70vh;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    padding: 24px;\n  }\n  \n  @media (max-width: 768px) {\n    padding: 7px;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.table-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 24px;\n\n  &__info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 13px;\n    font-weight: 700;\n    color: $bw-muted;\n  }\n\n  &__select-container {\n    select {\n      background: $bw-surface-soft;\n      border: 1px solid $bw-border;\n      border-radius: 12px;\n      padding: 6px 12px;\n      font-family: inherit;\n      font-weight: 700;\n      color: $bw-text;\n      outline: none;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:focus {\n        border-color: $bw-primary;\n        box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.1);\n      }\n    }\n  }\n}\n\n.table-responsive {\n  width: 100%;\n  flex: 1;\n  overflow-x: hidden;\n}\n\n.table-main {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 8px;\n\n  &__body{\n    background: $color-bg;\n    border-radius: 12px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-weight: 700;\n    color: $bw-text;\n    outline: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    @media (max-width: 1024px) {\n        padding: 0px;\n        background: transparent;\n    }\n  }\n\n  &__th-content {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-family: inherit;\n    transition: all 0.2s ease;\n  }\n\n  &__header {\n    background: $color-bg;\n    border-radius: 12px;\n  }\n\n  &__empty{\n    background: $color-bg;\n    border-radius: 12px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-weight: 700;\n    color: $bw-text;\n    outline: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  &__cell-text{\n    color: $bw-text;\n    font-weight: 700;\n    font-size: 14px;\n\n    @media (max-width: 768px) {\n        font-size: 11px;\n    }\n  }\n\n  > thead {\n    background:$color-bg;\n    border-radius: 12px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-weight: 700;\n    color: $bw-text;\n    outline: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  &__th {\n    padding: 12px 16px;\n    text-align: left;\n    vertical-align: middle;\n\n    @media (max-width: 1024px) {\n        padding: 12px 10px;\n    }\n    \n    &--sortable {\n      cursor: pointer;\n      &:hover .table-main__sort-icon { opacity: 1; color: $bw-primary; }\n    }\n  }\n\n  &__eyebrow {\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: $bw-muted;\n  }\n\n  &__sort-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0.35;\n    transition: all 0.2s ease;\n\n    svg {\n      font-size: 16px !important;\n    }\n  }\n\n  &__row {\n    background: #fafafa;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: $bw-surface-soft;\n      transform: translateY(-1px);\n    }\n\n    &--reminded {\n      background: rgba($bw-gold, 0.04);\n      .table-main__cell { border-top: 1px solid rgba($bw-gold, 0.1); border-bottom: 1px solid rgba($bw-gold, 0.1); }\n      &:hover { background: rgba($bw-gold, 0.07); }\n    }\n  }\n\n  &__cell {\n    padding: 24px;\n    border-top: 1px solid transparent;\n    border-bottom: 1px solid $bw-border;\n    font-size: 14px;\n    color: $bw-text;\n    font-weight: 500;\n\n    @media (max-width: 1024px) {\n        padding: 12px 10px;\n    }\n\n    &-wrapper { display: flex; align-items: center; gap: 12px; }\n  }\n\n  &__empty-state {\n    padding: 80px 0;\n    text-align: center;\n    color: $bw-muted;\n    p { font-weight: 600; font-size: 15px; }\n  }\n\n  @media (max-width: 768px) {\n    display: block;\n\n    thead { display: none; }\n    tbody { display: block; }\n    \n    &__row {\n      display: block;\n      background: #fff;\n      border: 1px solid $bw-border;\n      border-radius: 20px;\n      padding: 16px;\n      margin-bottom: 16px;\n      box-shadow: 0 4px 12px rgba(0,0,0,0.02);\n    }\n\n    &__cell {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      border: none;\n      padding: 8px 0;\n      text-align: right;\n\n      &::before {\n        content: attr(data-label);\n        font-size: 10px;\n        font-weight: 800;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n        color: $bw-muted;\n        text-align: left;\n      }\n    }\n\n    &__empty-row {\n      display: block;\n      width: 100%;\n    }\n\n    &__empty {\n      display: block;\n      width: 100%;\n      padding: 0;\n      border: none;\n      background: transparent;\n    }\n\n    &__empty-state {\n      width: 100%;\n      display: block;\n      padding: 60px 20px;\n    }\n  }\n}\n\n.table-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid $bw-border;\n\n  &__info {\n    font-size: 13px;\n    font-weight: 700;\n    color: $bw-muted;\n  }\n\n  @media (max-width: 768px) { flex-direction: column; gap: 20px; }\n}\n\n.pagination {\n  display: flex;\n  gap: 6px;\n\n  &__btn {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    border: 1px solid rgba(130, 177, 148, 0.3);\n    background: transparent;\n    color: $bw-muted;\n    font-weight: 800;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover:not(:disabled) {\n      background: rgba(130, 177, 148, 0.1);\n      border-color: $bw-primary;\n      color: $bw-text;\n    }\n\n    &--active {\n      background: $bw-primary !important;\n      color: #fff !important;\n      border-color: transparent !important;\n      box-shadow: 0 4px 12px rgba(130, 177, 148, 0.25);\n    }\n\n    &:disabled { opacity: 0.3; cursor: not-allowed; }\n  }\n\n  &__btn--arrow {\n    background: $bw-primary;\n    color: #fff;\n    border-color: transparent;\n    box-shadow: 0 4px 12px rgba(130, 177, 148, 0.25);\n  }\n\n  &__dots { padding: 0 4px; color: $bw-muted; font-weight: 800; }\n}\n\n.reminder {\n  position: relative;\n\n  &__tooltip-text{\n    color: $bw-text;\n    font-weight: 700;\n    font-size: 14px;\n  }\n\n  &__btn {\n    background: rgba($bw-gold, 0.1);\n    color: $bw-gold;\n    border: none;\n    border-radius: 10px;\n    padding: 6px;\n    cursor: pointer;\n    display: flex;\n    animation: softPulse 2s infinite;\n  }\n\n  &__tooltip {\n    position: absolute;\n    bottom: 130%;\n    left: 0;\n    width: 260px;\n    background: #fff;\n    border: 1px solid $bw-border;\n    border-radius: 16px;\n    padding: 16px;\n    box-shadow: 0 15px 40px rgba(0,0,0,0.15);\n    z-index: 100;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(10px);\n    transition: all 0.3s ease;\n  }\n\n  &:hover &__tooltip {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n\n  &__tooltip-inner {\n    display: flex;\n    gap: 12px;\n    text-align: left;\n    \n    strong { display: block; font-size: 13px; color: $bw-text; margin-bottom: 4px; }\n    p { margin: 0; font-size: 12px; color: $bw-muted; line-height: 1.5; }\n  }\n}\n\n@keyframes softPulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-wrapper": `Table_table-wrapper__Vdok+`,
	"table-toolbar": `Table_table-toolbar__jk1g8`,
	"table-toolbar__info": `Table_table-toolbar__info__SIlLB`,
	"table-toolbar__select-container": `Table_table-toolbar__select-container__3wc+-`,
	"table-responsive": `Table_table-responsive__pswaX`,
	"table-main": `Table_table-main__NtuYc`,
	"table-main__body": `Table_table-main__body__p+Eb-`,
	"table-main__th-content": `Table_table-main__th-content__zVKjd`,
	"table-main__header": `Table_table-main__header__aKq7c`,
	"table-main__empty": `Table_table-main__empty__pKe5c`,
	"table-main__cell-text": `Table_table-main__cell-text__EaZ9x`,
	"table-main__th": `Table_table-main__th__a2kdl`,
	"table-main__th--sortable": `Table_table-main__th--sortable__HlMYk`,
	"table-main__sort-icon": `Table_table-main__sort-icon__wFAhi`,
	"table-main__eyebrow": `Table_table-main__eyebrow__wMhvu`,
	"table-main__row": `Table_table-main__row__Yayus`,
	"table-main__row--reminded": `Table_table-main__row--reminded__5yVg7`,
	"table-main__cell": `Table_table-main__cell__lEwLp`,
	"table-main__cell-wrapper": `Table_table-main__cell-wrapper__ZQcjz`,
	"table-main__empty-state": `Table_table-main__empty-state__HRGT1`,
	"table-main__empty-row": `Table_table-main__empty-row__WU0tI`,
	"table-footer": `Table_table-footer__jW1kK`,
	"table-footer__info": `Table_table-footer__info__ik3Ft`,
	"pagination": `Table_pagination__GXBhQ`,
	"pagination__btn": `Table_pagination__btn__IIcxl`,
	"pagination__btn--active": `Table_pagination__btn--active__vTgB8`,
	"pagination__btn--arrow": `Table_pagination__btn--arrow__ftMQN`,
	"pagination__dots": `Table_pagination__dots__070qq`,
	"reminder": `Table_reminder__ZN3tb`,
	"reminder__tooltip-text": `Table_reminder__tooltip-text__k88MC`,
	"reminder__btn": `Table_reminder__btn__0HJkL`,
	"softPulse": `Table_softPulse__aL-xm`,
	"reminder__tooltip": `Table_reminder__tooltip__mKi-F`,
	"reminder__tooltip-inner": `Table_reminder__tooltip-inner__bDPBI`
};
export default ___CSS_LOADER_EXPORT___;
